export const FETCH_WORKFLOWS_URL = "https://64307b10d4518cfb0e50e555.mockapi.io/workflow";
export const FETCH_INDIVIDUAL_WORKFLOW = "https://64307b10d4518cfb0e50e555.mockapi.io/workflow/";
export const FETCH_MODULE_URL = "https://64307b10d4518cfb0e50e555.mockapi.io/modules"; 

export const initialNodes = [
    {
        "createdAt": "2023-04-07T05:30:15.521Z",
        "name": "Fantastic Concrete Towels",
        "input_type": "g",
        "output_type": "g",
        "id": "1"
    },
    {
        "createdAt": "2023-04-07T07:39:11.688Z",
        "name": "Practical Granite Bacon",
        "input_type": "j",
        "output_type": "w",
        "id": "2"
    },
    {
        "createdAt": "2023-04-07T00:41:18.141Z",
        "name": "Fantastic Wooden Hat",
        "input_type": "f",
        "output_type": "e",
        "id": "3"
    },
    {
        "createdAt": "2023-04-07T11:59:59.830Z",
        "name": "Gorgeous Wooden Keyboard",
        "input_type": "d",
        "output_type": "s",
        "id": "4"
    },
    {
        "createdAt": "2023-04-07T19:13:24.647Z",
        "name": "Handcrafted Cotton Bike",
        "input_type": "i",
        "output_type": "t",
        "id": "5"
    }
]